import React, { useState, useContext, useEffect } from 'react'
import { Col, Row, Form, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMobileAlt, faTabletAlt, faGlobeAsia, faUserCircle, faWindowMaximize } from '@fortawesome/free-solid-svg-icons'
import { NotifyContext } from '../Library/Notify'
import { LanguageContext } from '../Language/LanguageContext'
import { updateUser, viewUser, addUserRole, removeUserRole } from "../Network/User"
import { useHistory, useParams } from 'react-router-dom'
import { Loading, HeaderTitle } from '../Library'
import { listCompany } from '../Network/Company'
import { listDepartment, addUserToDepartment, removeFromDepartment } from '../Network/Department'
import { listRole } from '../Network/Role'
import MultiSelect from "react-multi-select-component";
import "./UserDetail.css"
import { setDocumentTitle } from '../AppTitle'
import { RoleContext } from "../Role/RoleContext"

function EditUser() {
    const rolecx = useContext(RoleContext)
    const prefixAuthority = "NEWS_"
    const globalAuthority = "SET_GLOBAL"
    const companyAuthority = "SET_COMPANY"

    const langCx = useContext(LanguageContext);
    const lang = langCx.lang.user
    const notifyCx = useContext(NotifyContext);
    const history = useHistory();
    const { userid } = useParams();

    const [isLoading, setLoading] = useState(false);
    const [loadingTitle, setLoadingTitle] = useState("Loading");

    const [employeeId, setEmployeeId] = useState("");
    const [currentUsername, setCurrentUsername] = useState("");
    const [username, setUsername] = useState("");
    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [position, setPosition] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [line, setLine] = useState("");
    const [email, setEmail] = useState("");
    const [isError, setError] = useState(false);
    const [profile, setProfile] = useState("");

    const [companyList, setCompanylist] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState("");

    const [departmentList, setDepartmentlist] = useState([]);
    const [oldDepartment, setOldDepartment] = useState("");
    const [selectedDepartment, setSelectedDepartment] = useState("");

    const [isMobile, setMobile] = useState(false)
    const [isWeb, setWeb] = useState(false)
    const [isTablet, setTablet] = useState(false)
    const [isInformationScreen, setIsInformationScreen] = useState(false)

    const [role, setRole] = useState([])
    const [prevSelectedRole, setPrevSelectedRole] = useState("")
    const [selectedRole, setSelectedRole] = useState("")

    useEffect(() => {
        setDocumentTitle("Edit user")
        const fetchData = () =>{
            setLoadingTitle(lang.loading_data)
            setLoading(true)
            viewUser(userid,
                (data)=>{
                    let user = data.user
                    let role = data.roles
                    console.log(data)
                    setEmployeeId(user.employeeId)
                    setCurrentUsername(user.username)
                    setUsername(user.username)
                    setFirstname(user.firstName)
                    setLastname(user.lastName)
                    setPosition(user.position)
                    setPhoneNumber(user.phone)
                    setLine(user.line)
                    setMobile(user.isMobile)
                    setWeb(user.isCms)
                    setTablet(user.isTablet)
                    setIsInformationScreen(user.isInformation)
                    setEmail(user.email)
                    setProfile(user.profileImagePath)
                    if(data.company !== null){
                        let companyId = data.company.id
                        setSelectedCompany(companyId)
                        fetchDepartment(companyId)
                    }
                    if(data.departments !== null){
                        setOldDepartment(data.departments[data.departments.length - 1].id)
                        setSelectedDepartment(data.departments[data.departments.length - 1].id)
                    }
                    // var roleList = []
                    // role.map((item)=>{
                    //     roleList.push({value: item.roleId, label: item.roleName})
                    // })
                    if(role.length > 0){
                        setPrevSelectedRole(role[0].roleId)
                        setSelectedRole(role[0].roleId)
                    }
                    setLoading(false)
                },
                (error)=>{
                    setLoading(false);
                    notifyCx.showNotify("Error get user information", error.message, 2)
                })
        }
        fetchRole()
        fetchData()
        fetchCompany()
    }, [])

    const fetchCompany = () =>{
        listCompany(
            (data)=>{
                setCompanylist(data)
            },
            (error)=>{
                setLoading(false)
                notifyCx.showNotify("Error get company list", error.message, 2)
            }
        )
    }

    const fetchDepartment = (companyId) =>{
        listDepartment(companyId,
            (data)=>{
                setDepartmentlist(data)
            },
            (error)=>{
                notifyCx.showNotify("Error get department list", error.message, 2)
            })
    }

    const fetchRole = () =>{
        listRole(1, 1000,
            (data)=>{
                var roleList = []
                data.map((item)=>{
                    roleList.push({value: item.id, label: item.roleName})
                })
                setRole(roleList)
            },
            (error)=>{
                notifyCx.showNotify(lang.something_wrong, error.message, 2)
            })
    }

    const addDepartment = () =>{
        if(oldDepartment !== selectedDepartment){
            removeFromDepartment(userid, oldDepartment,
                ()=>{ },
                (error)=>{  })
        }

        addUserToDepartment(userid, selectedDepartment,
            ()=>{
                setLoading(false)
                notifyCx.showNotify(
                    lang.updated_user,
                    lang.updated_user_desc, 
                    0)
                history.push("/user")
            },
            (error)=>{
                notifyCx.showNotify("Error add department", error.message, 2)
            })
    
    }

    const addRoleToUser = () =>{
        // selectedRole.map((item)=>{
        //     if(!prevSelectedRole.find(el=>el.value === item.value)){
        //         addUserRole(userid, item.value,
        //             ()=>{  },
        //             (error)=>{
        //                 notifyCx.showNotify("Error", error.message, 2)
        //             })
        //     }
        // })

        // prevSelectedRole.map((item)=>{
        //     if(!selectedRole.find(el=>el.value === item.value)){
        //         removeUserRole(userid, item.value,
        //             ()=>{},
        //             (error)=>{
        //                 notifyCx.showNotify("Error", error.message, 2)
        //             })
        //     }
        // })
        if(prevSelectedRole !== selectedRole){
            removeUserRole(userid, prevSelectedRole,
                ()=>{},
                (error)=>{ notifyCx.showNotify("Error", error.message, 2) })
        }

        if(prevSelectedRole !== selectedRole){
            addUserRole(userid, selectedRole,
                ()=>{ },
                (error)=>{ notifyCx.showNotify("Error", error.message, 2) })
        }
    }

    const onSubmit = () =>{
        if( !selectedCompany || !selectedDepartment ||
            !employeeId || !username || !firstname || !lastname || !position || 
            !phoneNumber || !email){ 
            notifyCx.showNotify(lang.not_complete, lang.not_complete_desc, 1)
            setError(true);
            return;
        }
        else if(!isMobile && !isTablet && !isWeb){
            notifyCx.showNotify(lang.access_not_select, lang.access_not_select_desc, 1)
            setError(true);
            return;
        }
        setLoadingTitle(lang.updating)
        setLoading(true);

        var newUsername = null
        if(username !== currentUsername){
            newUsername = username
        }
        
        updateUser(
            userid,
            newUsername,
            firstname,
            lastname,
            position,
            phoneNumber,
            email,
            isWeb,
            isMobile,
            isTablet,
            isInformationScreen,
            ()=>{
                addDepartment();
                addRoleToUser();
            },
            (error)=>{
                setLoading(false)
                notifyCx.showNotify("Error", error.message, 2)
            }
        )
    }

    return (
        <>
        { isLoading ? <Loading title={loadingTitle}/>: null }
        <div id="create-user">
            <HeaderTitle title={lang.edit_user} isShowBack backTo="/user"/>
            <Row style={{width: "100%"}}>
                <Col className="content-container" md={10} lg={8} xl={6}>
                    <Form
                    onSubmit={(e)=>{
                        e.preventDefault();
                        onSubmit();
                    }}
                    >
                        <Form.Group>
                            <Form.Label>{lang.company}</Form.Label>
                            <Form.Control as="select"
                            value={selectedCompany}
                            disabled={!rolecx.checkPermission(prefixAuthority, companyAuthority) ? true:false}
                            isInvalid={isError && !selectedCompany}
                            onChange={(e)=>{
                                let companyId = e.target.value
                                setSelectedCompany(companyId)
                                if(companyId !== ""){
                                    setSelectedDepartment("")
                                    fetchDepartment(companyId)
                                }else{
                                    setDepartmentlist([])
                                }
                            }}>
                                <option
                                value={""}
                                >
                                    {lang.select_company}
                                </option>
                                { companyList.map((item, key)=>
                                <option 
                                key={key}
                                value={item.id}
                                >
                                    {item.name}
                                </option>
                                )}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.department}</Form.Label>
                            <Form.Control 
                            value={selectedDepartment}
                            isInvalid={isError && !selectedDepartment}
                            disabled={!selectedCompany ? true:false}
                            onChange={(e)=>setSelectedDepartment(e.target.value)}
                            as="select">
                                <option value="">{lang.select_department}</option>
                                { departmentList.map((item, key)=>
                                <option 
                                key={key}
                                value={item.id}>
                                    {item.name}
                                </option>
                                )}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.username}</Form.Label>
                            <Form.Control
                            value={username}
                            isInvalid={isError && !username}
                            onChange={(e)=>setUsername(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.firstname}</Form.Label>
                            <Form.Control
                            placeholder="John"
                            value={firstname}
                            isInvalid={isError && !firstname}
                            onChange={(e)=>setFirstname(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.lastname}</Form.Label>
                            <Form.Control
                            placeholder="Seed"
                            value={lastname}
                            isInvalid={isError && !lastname}
                            onChange={(e)=>setLastname(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.position}</Form.Label>
                            <Form.Control
                            placeholder="Building Admin"
                            value={position}
                            isInvalid={isError && !position}
                            onChange={(e)=>setPosition(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.phone}</Form.Label>
                            <Form.Control
                            value={phoneNumber}
                            isInvalid={isError && !phoneNumber}
                            onChange={(e)=>setPhoneNumber(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.email}</Form.Label>
                            <Form.Control
                            placeholder="johns@qhouse.co.th"
                            value={email}
                            isInvalid={isError && !email}
                            onChange={(e)=>setEmail(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.role}</Form.Label>
                            {/* <MultiSelect
                            options={role}
                            value={selectedRole}
                            onChange={setSelectedRole}
                            
                            /> */}
                            <Form.Control 
                            value={selectedRole}
                            onChange={(e)=>{
                                setSelectedRole(e.target.value)
                            }}
                            as="select">
                                <option value="">{lang.select_role}</option>
                                { role.map((item, key)=>
                                <option key={key} value={item.value}>{item.label}</option>
                                )}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group >
                            <Form.Label>
                                {lang.access_platform}
                                <div className="label-desc">
                                    {lang.access_platform_desc}
                                </div>
                            </Form.Label>
                            
                            <div style={{display: 'flex'}}>
                            <AccessItem title={lang.mobile} 
                            icon={faMobileAlt} isSelected={isMobile}
                            isError={!isMobile && !isWeb && !isTablet && !isInformationScreen && isError}
                            onClick={()=>setMobile(!isMobile ? true: false)}
                            />
                            { rolecx.checkPermission("_MENU_", "app.admin_select") ?
                            <AccessItem title={lang.web_admin} 
                            icon={faGlobeAsia} isSelected={isWeb}
                            isError={!isMobile && !isWeb && !isTablet && !isInformationScreen && isError}
                            onClick={()=>setWeb(!isWeb ? true: false)}
                            />
                            : null
                            }
                            { rolecx.checkPermission("_MENU_", "app.tablet_select") ?
                            <AccessItem title={lang.tablet} 
                            icon={faTabletAlt} isSelected={isTablet}
                            isError={!isMobile && !isWeb && !isTablet && !isInformationScreen && isError}
                            onClick={()=>setTablet(!isTablet ? true: false)}
                            />
                            : null
                            }
                            { rolecx.checkPermission("_MENU_", "app.front_screen") ?
                            <AccessItem
                            title={lang.information_screen}
                            icon={faWindowMaximize}
                            isSelected={isInformationScreen}
                            isError={!isMobile && !isWeb && !isTablet && !isInformationScreen && isError}
                            onClick={()=>setIsInformationScreen(!isInformationScreen ? true:false)}
                            />
                            : null
                            }
                            </div>
                        </Form.Group>
                        <hr/>
                        <Form.Group>
                            <Button type="submit" style={{marginTop: 30}}>{lang.save_change}</Button>
                        </Form.Group>
                        
                    </Form>
                </Col>
                <Col md={2} lg={4} xl={6} style={{textAlign: 'center'}}
                className="d-none d-lg-block">
                    <div className="profile-container">
                        { profile !== "" ?
                        <img src={profile} className="profile-img"/>
                        :
                        <FontAwesomeIcon icon={faUserCircle}/>
                        }
                    </div>
                    <div>
                        <b>{lang.current_profile}</b>
                    </div>
                </Col>
            </Row>
        </div>
        </>
    )
}

function AccessItem(props){
    return(
        <div className="access-item"
        onClick={props.onClick}
        role="button"
        tabIndex="0"
        aria-pressed="false"
        onKeyDown={(e)=>{
            if(e.key === "Enter"){
                props.onClick()
            }
        }}
        style={{
            borderColor: props.isError ? "red": "lightgray",
            color: props.isSelected ? "white" : "black",
            backgroundColor: props.isSelected ? "#0275d8": "white"
        }}
        >
            <div>
                <div className="icon">
                    <FontAwesomeIcon icon={props.icon}/>
                </div>
                <div className="title">{props.title}</div>
            </div>
        </div>
    )
}

function RoleList(){
    return(
        <div>
            <b className="title-role">Role</b>
            <div>
                <div className="role-item">
                    <div>System admin</div>
                    <div className="desc">Description here</div>
                </div>
            </div>
        </div>
    )
}

export default EditUser
